import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { MOVE_LABELS, useWh } from "@/lib/wh";
import { WhSwitch } from "@/components/wh/WhSwitch";
import { MovementList } from "@/components/wh/MovementList";

export default function WhMovements() {
  const [type, setType] = useState("");
  const [rows, setRows] = useState([]);
  const { wh } = useWh();
  useEffect(() => {
    api.get("/wh/movements", { params: { wh, type, limit: 500 } }).then(({ data }) => setRows(data)).catch((e) => toast.error(formatApiError(e)));
  }, [type, wh]);
  return (
    <div className="space-y-6">
      <Link to="/magazzino" className="text-sm text-[var(--muted)] flex items-center gap-1" data-testid="wh-back"><ArrowLeft className="h-4 w-4" /> Magazzino</Link>
      <div className="fade-up"><p className="eyebrow">Magazzino</p><h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Storico movimenti</h1></div>
      <WhSwitch />
      <select value={type} onChange={(e) => setType(e.target.value)} className="h-10 rounded-md border border-[var(--border)] px-3 text-sm bg-white" data-testid="wh-movement-type">
        <option value="">Tutti i movimenti</option>{Object.entries(MOVE_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <MovementList rows={rows} showItem />
    </div>
  );
}
